import validate from "./validate";

export default validate;
